/**
 * Corporate feature-flag guard for all shuttle routes. The shuttle feature is gated by the
 * per-corporate GeneralSetting `isShuttleEnabled` (YES/NO) — the same mechanism as billing.
 * If a corporate doesn't have shuttle enabled, direct navigation to any /shuttle/* URL is
 * bounced to the 404 page (SUPERADMIN is exempt, matching the masterRoutes self-guard).
 */
import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useAuthUser} from '@crema/utility/AuthHooks';

const ShuttleGuard = ({children}) => {
  const navigate = useNavigate();
  const {user} = useAuthUser();
  const generalSettings = useSelector(({settings}) => settings.generalSettings);
  const isSuperAdmin = user?.userList?.userRole === 'SUPERADMIN';
  const shuttleEnabled = generalSettings?.isShuttleEnabled === 'YES';

  useEffect(() => {
    // Wait until settings have loaded before deciding (avoid a false redirect on first paint).
    if (!generalSettings) return;
    if (!shuttleEnabled && !isSuperAdmin) navigate('/error-pages/error-404');
  }, [generalSettings, shuttleEnabled, isSuperAdmin, navigate]);

  if (generalSettings && !shuttleEnabled && !isSuperAdmin) return null;
  return children;
};

export default ShuttleGuard;
